const model = [
  {
    key: 'legacyPostId',
    label: 'Product Id',
    minWidth: 100,
  },
  {
    key: 'imageUrl',
    label: 'Thumbnail Image',
    minWidth: 130,
  },
  {
    key: 'brandName',
    label: 'Brand Name',
    minWidth: 130,
    type: 'string',
  },
  {
    key: 'productName',
    label: 'Product Name',
    minWidth: 275,
    type: 'string',
  },
  {
    key: 'sku',
    label: 'SKU',
    minWidth: 120,
  },
  {
    key: 'retailPrice',
    label: 'Retail Price',
    minWidth: 100,
    type: 'number',
  },
  {
    key: 'isPublic',
    label: 'Public',
    minWidth: 100,
    type: 'boolean',
  },
];

export default model;
